import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { guard } from 'util/core-transition-component';
import type { GuardFunction } from 'util/core-transition-component';
import useRouterPush from './useRouterPush';
import { useGlobalStore } from '../stores/global';
import { stripLocaleFromUrl, stripQueriesFromUrl } from '../util/url.utils';

// todo (Should probably only create 1 router.events.on and keep track of the 'guards/release')
// as it's triggered twice after a build when used on two spots.
export const useBeforeHistoryChange = (beforeRelease?: GuardFunction): void => {
  // const [leaveConfirmed, setLeaveConfirmed] = useState(false);
  const leaveConfirmed = useRef(false);
  const beforeReleaseRef = useRef(beforeRelease);
  const router = useRouter();
  const currentPath = useRef(stripLocaleFromUrl(router.asPath));
  const routerPush = useRouterPush();
  const store = useGlobalStore();

  useEffect(
    () => {
      const beforeHistoryChange = (url: string) => {
        const cleanUrl = stripLocaleFromUrl(url, router.locale);
        // cleanUrl = stripQueriesFromUrl(cleanUrl);

        if (
          leaveConfirmed.current ||
          stripQueriesFromUrl(cleanUrl) === stripQueriesFromUrl(currentPath.current)
        )
          return;

        router.events.emit('routeChangeError', cleanUrl, currentPath.current);

        throw `Route change to "${url}" was aborted (this error can be safely ignored)`;
      };

      const onRouteChangeError = (toPath: string, fromPath: string) => {
        store.setBeforeHistoryChangePath(toPath, fromPath);

        guard(() => {
          router.events.off('beforeHistoryChange', beforeHistoryChange);
          router.events.off('routeChangeError', onRouteChangeError);
          leaveConfirmed.current = true;
          routerPush(toPath);
        }, beforeReleaseRef.current);
      };

      router.events.on('routeChangeError', onRouteChangeError);
      router.events.on('beforeHistoryChange', beforeHistoryChange);

      return () => {
        router.events.off('beforeHistoryChange', beforeHistoryChange);
        router.events.off('routeChangeError', onRouteChangeError);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
};
